import axios from 'axios'
import { errorHandler } from '../exports/error_management'

import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-crm-opportunity-type-key'

const api = async (method, path, params) => axios[method](path, params)

const state = {
    crm_opportunity_type: null,
    crm_opportunity_types: [],
}

const mutations = {
    set_opportunity_type(state, payload) {
        state.crm_opportunity_type = payload
    },
    set_crm_opportunity_types(state, payload) {
        state.crm_opportunity_types = payload
    },
}

const actions = {
    async create(context, payload) {
        try {
            const results = await api('post', `crm-opportunity-type`, payload)
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_opportunity_type', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.crm_opportunity_types },
                data,
                null
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            await context.dispatch('fetchAll')
            context.commit(
                'set_crm_opportunity_type',
                context.state.crm_opportunity_types.find(x => x.id == id)
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { value } = storageCache.getArray()
            // if (!is_valid) {
                const results = await api('get', `crm-opportunity-type`)
                console.log('results.data', results.data)
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            // }
            context.commit('set_crm_opportunity_types', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateCrmOpportunityTypeOrder(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
             await api(
                'post',
                `crm-opportunity-type/update/display/order/`,
                payload
            )
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `crm-opportunity-type/${payload.id}`,
                payload
            )
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_crm_opportunity_type', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.crm_opportunity_types },
                data,
                payload.id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        try {
            await api('delete', `crm-opportunity-type/${id}`)
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_crm_opportunity_type', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.crm_opportunity_types },
                null,
                id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
